// This service loads constants from the api, the constants are defined in constants.json on the server.
//
// constants.json

// {
//   "PROJECT_ROLES" : [
//     "owner",
//     "manager",
//       "contributor",
//     "guest"
//   ],
//   "FUNCTIONALITIES" : [
//     { "_id": 2, "name": "NFNO", "description": "niet functionele ruimte" },
//     { "_id": 1, "name": "FNO",  "description": "functionele ruimte" },
//     { "_id": 3, "name": "SAN",  "description": "sanitair" },
//     { "_id": 4, "name": "VER",  "description": "verkeersruimte" }
//     { "_id": 5, "name": "BUI",  "description": "buitenruimte" }
//   ],
//  .....
//
// If you want the record from FUNCTIONALITIES where name = SAN you can call:
//
//      Constants.fromList('FUNCTIONALITIES', 'SAN', 'name');
//
//  the 3rd argument is optional, default is '_id'
//
// If you want a list of constants you call:
//
//      Constants.getList('PROJECT_ROLES')
//

(function () {

  'use strict';

  angular
    .module('specsguardApp')
    .service('Constants', constantsService);

  constantsService.$inject = ['$log', '$resource'];

  function constantsService ($log, $resource) {
    const constantsResource = $resource('/api/app/constants');
    let constants = null;

    function getConstants () {
      if (constants) {
        return Promise.resolve(constants);
      }

      return constantsResource.get().$promise.then(function (res) {
        constants = res.toJSON();
        return Promise.resolve(constants);
      });
    }

    function getList (name) {
      if (!constants) {
        $log.error('constants have not been loaded');
      }
      return constants[name] || [];
    }

    function fromList (name, value, identifier = '_id') {
      const list = getList(name);
      const l = list.length;
      let result = {};

      for (let i = 0; i < l; i++) {
        if (list[i][identifier] === value) {
          result = list[i];
          break;
        }
      }

      return result;
    }

    function attributeToType (attribute) {
      if (attribute !== 'requirementStrictness') {
        attribute += 's';
      }
      return attribute.replace(/([A-Z])/g, '_$1').toUpperCase();
    }

    function getAll () {
      return constants;
    }

    function invalidate () {
      constants = null;
    }

    return {
      getConstants: getConstants,
      getList: getList,
      fromList: fromList,
      attributeToType: attributeToType,
      getAll: getAll,
      invalidate,
    };
  }

})();
